import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubheaderComponent } from './subheader.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
		CommonModule,
		TranslateModule,
		MatSelectModule,
		FormsModule      
    ],
    declarations: [SubheaderComponent],
    exports: [SubheaderComponent]
})
export class SubheaderModule { }
